export default [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
    ],
    name: 'getBurnLimitParams',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lastUpdateTimestamp',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'ratePerSecond',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxLimit',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lastUpdateLimit',
            type: 'uint256',
          },
        ],
        internalType: 'struct Gauge.LimitParams',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
    ],
    name: 'getCurrentBurnLimit',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
    ],
    name: 'getCurrentMintLimit',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'msgGasLimit_',
        type: 'uint256',
      },
    ],
    name: 'getMinFees',
    outputs: [
      {
        internalType: 'uint256',
        name: 'totalFees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
    ],
    name: 'getMintLimitParams',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lastUpdateTimestamp',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'ratePerSecond',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxLimit',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lastUpdateLimit',
            type: 'uint256',
          },
        ],
        internalType: 'struct Gauge.LimitParams',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'poolLockedAmounts',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token_',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'rescueTo_',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount_',
        type: 'uint256',
      },
    ],
    name: 'rescueFunds',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalMinted',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'receiver_',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'burnAmount_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'msgGasLimit_',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'connector_',
        type: 'address',
      },
    ],
    name: 'withdrawFromAppChain',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
] as const
